var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Doc"}},[_c('b-container',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})]),_c('b-container',{staticClass:"footer text-center",attrs:{"fluid":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }